import React from 'react';
import styled from 'styled-components';

import { Text } from '../ui-components';

/**
 * Rich-renderer function that can be consumed by React-Rich-Text render in order
 * to generate a styled element based on a particular rich text node, and it's
 * children
 *
 * @function
 * @param {object} node rich-text node
 * @param {element} children collection of child rich-text nodes
 * @param {string} font size for text
 */
const RichParagraph = (node, children, fontSize = 'large') => <StyledText size={fontSize}>{children}</StyledText>;

const StyledText = styled(props => <Text {...props} />)`
  margin-bottom: 24px;
`;

export default RichParagraph;
